import { e2eeDecrypt } from 'features/e2ee/utils/e2eeDecrypt';
import { fileToBase64, urlToArrayBuffer } from 'utils/file';
import { decryptFile } from 'features/e2ee/utils/decryptFile';
import { parseRecordSafely } from 'utils/whiteboard/parseRecordSafely';
import { isSettingRecord, WhiteboardRecord } from 'utils/whiteboard/settings';

export const decryptWBRecords = async (encryptedRecords: string[], decryptionKey: CryptoKey) => {
  const decryptionPromises = encryptedRecords.map<Promise<WhiteboardRecord | null>>(
    async (row: string) => {
      const decryptedData = await e2eeDecrypt(row, decryptionKey);
      const record = parseRecordSafely(decryptedData) as WhiteboardRecord | null;

      if (!record || isSettingRecord(record)) {
        return record;
      }

      if (record.typeName === 'asset' && record.props.src) {
        const { src } = record.props;

        const encryptedFile = await urlToArrayBuffer(src);
        if (encryptedFile) {
          const decryptedBlob = await decryptFile(encryptedFile, decryptionKey);

          // preserve the original url with the encrypted file
          record.props.src = await fileToBase64(decryptedBlob);
          record.meta = {
            ...record.meta,
            src,
          };
        }
      }

      return record;
    }
  );

  const records = await Promise.all(decryptionPromises);

  return records.filter(Boolean) as WhiteboardRecord[];
};
